import React, {useState} from 'react';
import apis from "services";
import {useQuery} from "react-query";
import {useDispatch} from "react-redux";
import {Message, MessagesList} from "views";
import {setOptionsAction} from "redux/actions";
import {Redirect, Route, Switch} from "react-router-dom";
import {Header, Sidebar, Toolbar} from "components";
//Material UI Component
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex'
    },
    content: {
        flexGrow: 1,
        marginTop: '3em',
    },
}));

const App = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [drawerOpen, setDrawerOpen] = useState(false);

    useQuery('options', apis.optionsApi, {
        onSuccess: ({data}) => dispatch(setOptionsAction(data)),
        onError: err => console.log('ERROR:', err)
    });

    const toggleDrawer = () => setDrawerOpen(!drawerOpen);

    return (
        <div className={classes.container}>
            <Header toggleDrawer={toggleDrawer}/>
            <Sidebar open={drawerOpen} setOpen={setDrawerOpen}/>
            <main className={classes.content}>
                <Toolbar/>
                <Switch>
                    <Route exact path="/" render={() => <Redirect to="/primary"/>}/>
                    <Route exact path={["/", "/:tab"]} component={MessagesList}/>
                    <Route path="/message/:id" component={Message}/>
                </Switch>
            </main>
        </div>
    );
};

export default App;
